import { useRef, useState, useEffect } from "react";

import "./testimonials.css";
import QuoteAuthor from "./QuoteAuthor";
import { v4 as uuidv4 } from 'uuid';
import QuoteContentContainer from "./QuoteContentContainer";
import CircleIconButton from "../../../common/Buttons/CircleIconButton";

// Testimonal Structure
class Testimonial {
    constructor(authorName, authorRole, quoteHeading, quoteContent) {
        this.authorName = authorName;
        this.authorRole = authorRole;
        this.quoteHeading = quoteHeading;
        this.quoteContent = quoteContent;
        this.key = uuidv4();
    }
} 

// List of testimonials
const testimonials = [
    new Testimonial("Jenny Wilson", "CEO, Co-Founder", "Thanks to you, we have created a unique branding that is our pride!", "Duis sapien velit, rutrum ac rutrum dapibus, auctor ut lacus. Aenean sit amet erat augue. Aenean finibus, nibh sed malesuada maximus, nisi tellus iaculis quam, eget egestas mi felis eu urna. Quisque id nisl commodo, egestas eros ac, cursus odio. Ut nec rutrum magna."),
    new Testimonial("Robert Fox", "Marketing Coordinator", "Exceptional work, delivery and flexibility. An excellent result.", "Duis sapien velit, rutrum ac rutrum dapibus, auctor ut lacus. Aenean sit amet erat augue. Aenean finibus, nibh sed malesuada maximus, nisi tellus iaculis quam, eget egestas mi felis eu urna. Quisque id nisl commodo, egestas eros ac, cursus odio. Ut nec rutrum magna.")
]

export default function Testimonials() {
    // https://stackoverflow.com/a/74202954
    const [swiperKey, setSwiperKey] = useState(0);

    // Keeps track of which quote is currently displayed.
    const [quoteIndex, setQuoteIndex] = useState(0);

    // Quote to be rendered.
    const [quote, setQuote] = useState(testimonials[0]);

    // https://stackoverflow.com/a/74202954
    useEffect(() => {
        setSwiperKey(1);
    }, []);

    // Render next quote.
    const handleSlideChange = (next) => {
        const nextIndex = quoteIndex + (next ? 1 : -1);

        const currentTestimonial = testimonials[nextIndex];
        setQuote(currentTestimonial);

        setQuoteIndex(nextIndex);
    }

    // References to previous and next button.
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    return (
        <section id="testimonials" className="desktop-only">
            <div className="qoute-container">
                <div className="quote-info">
                    <i className="ai-quotes d-none d-md-block text-primary ms-n2 mb-1" style={{ fontSize: "100px" }} ></i>
                    <QuoteAuthor author={quote.authorName} role={quote.authorRole} />
                    {/* Navigation */}
                    <div className="d-flex align-items-center pb-2 pb-md-0 pt-4 mt-3">
                        <CircleIconButton icon="ai-arrow-left" ref={prevRef} />
                        <span>{quoteIndex + 1} / {testimonials.length}</span>
                        <CircleIconButton icon="ai-arrow-right" ref={nextRef} />
                    </div>
                </div>

                <QuoteContentContainer
                    testimonials={testimonials}
                    prevRef={prevRef}
                    nextRef={nextRef}
                    handleSlideChange={handleSlideChange}
                />

            </div>
        </section>
    )
}
